import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

function WhatsAppFloat({ visible })
 {
  const [open, setOpen] = useState(false);
  
  const [isMobile, setIsMobile] = useState(false);

  const phoneNumber = "919158914222";
  const message = "Hello, I want to know about home construction.";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  const callLink = `tel:+${phoneNumber}`;
  const mailLink = `mailto:dwellorahomes@gmail.com`;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    // <div
    //   className={`float-wrapper ${open ? "active" : ""}`}
    //   onMouseLeave={() => !isMobile && setOpen(false)}
    // >

<div
  className={`float-wrapper 
    ${open ? "active" : ""} 
    ${visible ? "show-float" : "hide-float"}`}
  onMouseLeave={() => !isMobile && setOpen(false)}
>

      {/* Floating Options */}
      <div className="float-box">
        <a href={whatsappLink} target="_blank" rel="noreferrer" className="float-icon whatsapp">
          <i className="bi bi-whatsapp"></i>
        </a>

        <a href={callLink} className="float-icon call">
          <i className="bi bi-telephone-fill"></i>
        </a>

        <a href={mailLink} className="float-icon mail">
          <i className="bi bi-envelope-fill"></i>
        </a>
      </div>

      {/* Main Button */}
      <button
        className="float-main-btn"
        onMouseEnter={() => !isMobile && setOpen(true)}
        onClick={() => setOpen(!open)}
      >
        {/* Desktop Text */}
        {!isMobile && (
          <span className="float-text">Get in Touch</span>
        )}

        <span className="float-circle">
          {isMobile ? (
            <i className="bi bi-chat-left-text-fill"></i>   
          ) : open ? (
            <i className="bi bi-x-lg"></i>
          ) : (
            <i className="bi bi-chat-left-text-fill"></i>
          )}
        </span>
      </button>
    </div>
  );
}

export default WhatsAppFloat;